export const addLeadingZero = (value: number): string =>
  value >= 0 && value < 10 ? `0${value}` : String(value);
